<template>
    <div>
    <div id="opa">
     <div class="title_left">{{ title }}</div>
     <div class="skrzyniegrid">
	<div class="items">
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="false" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected='rowSelected' :rowDeselected="rowSelected"> 
			<e-columns>
				<e-column field='id_rodzaju_skrzyni' headerText='ID typu' :visible="false"></e-column>
				<e-column field='id' headerText='ID' :visible="false"></e-column>
				<e-column field='id_dokumentu_magazynowego' headerText='Id dokumentu' :visible="false"></e-column>
				<e-column field='nazwa' headerText='Numer skrzyni' width='200'></e-column>
				<e-column field='Typ_skrzyni' headerText='Typ skrzyni' width='200'></e-column>
				<e-column field='liczbaPlatonow' headerText='Platony' width='100'></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
	</div>
     </div>
     <!-- <div class="dokpz_right">
        <div v-for="(item,index) in data" :key="index">
                <SkrzyniaWydanie :nazwa="item.typ_skrzyni" :ident="index"/>
        </div>
      </div> -->
    </div>
    <div class="wbottom">
      <div class="wleft">
           <button class="wlabel"> WRÓĆ </button>
      </div>
      <div class="wcenter">
	<div id="scanning" style="display:none">
		<div class="spinner"></div>
	</div>
	<input type="text" style="opacity: 0;" id="skaner"/>
	<label id="notfound" style="display:none;"></label>
        <button id="read" style="display:none;"></button>
      </div>
      <div class="wright">
      <div>
       <!-- <div v-show="showwaga"> -->
                <button class="wlabel do_wagicommit"> PRZEJDŹ DO WAGI </button>
       </div>
      </div>
    </div>
   </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
import { opakowanie_dane } from "./opakowanie_dane.js";
import SkrzyniaWydanie from "@/components/SkrzyniaWydanie";
import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);
Vue.use(SkrzyniaWydanie);

export default {
  name: "opakowanie",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: opakowanie_dane.items,
	data: [],
	url: "/agent/GALEK.Magazyn/GetWydanieSkrzynie",
	title: "Podaj opakowanie",
	selectionOptions: { type: 'Multiple', enableSimpleMultiRowSelection: true, allowColumnSelection: false },
	whereto: "",
	mag: "",
        typ_zlecenia: "",
	backto: "",
	jwt: "",
	skr: 0,
	skrzynia_id: -1,
	showwaga: false,
   }),
   provide: {
	grid: [Page, Sort, Filter, Group]
   },
   methods: { 
	dowagiclick() {
		//alert("Przejdź do wagi");
		var typy_skrzyn = [];
		var ilosci_skrzyn = [];
    		let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
    		let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
                
		//selectedrowindex.forEach( e => ilosci_skrzyn.push(Number(document.querySelector('#skrzynia' + e).value)) );
		selectedrecords.forEach( e => typy_skrzyn.push(e.id ) );
		

		var skrzynie = "";
		var suma_skrzyn = 0;
		if (typy_skrzyn.length > 0) {
			for (var i=0; i<typy_skrzyn.length; i++) {
                                skrzynie += typy_skrzyn[i] + "," + 1;
                                
                                if (i != (typy_skrzyn.length - 1)) {
                                        skrzynie += ";";
                                }
			}
			//console.log("SKRZYNIE: " + skrzynie);
			this.$router.push({ path: "/waga" + this.whereto + "&id_skrzyni=" + skrzynie});
		} else {
			alert("Należy wybrać chociaż jedną skrzynię aby przejść do wagi.");
		}
	},
	skanerclick() {
                console.log("focus...");
                document.querySelector("#skaner").focus();
        },
        skanerstart() {
                console.log("scanning started...");
                document.querySelector("#read").style.display='none';
                document.querySelector("#notfound").style.display='none';
                document.querySelector("#scanning").style.display='block';
        },
        skanerend() {
                console.log("scanning finished...");
                document.querySelector("#scanning").style.display='none';
                document.querySelector("#notfound").style.display='block';
                document.querySelector("#read").style.display='none';
        },
        skanertext() {
                var valx = document.querySelector("#skaner").value;
                console.log("VALUE pasted: " + valx);
                document.querySelector("#skaner").value = "";
                let success = this.pickUpRow(valx);
                if (!success) {
                        // lets try again without last part 
                        let parts = valx.split('/');
                        if (parts.length > 0) {
                                parts.pop();
                                let nparts = parts.join('/');
                                console.log("NEW pattern to check: " + nparts);
                                this.pickUpRow(nparts); 
                        }
                }
                this.skanerend();
        },
	pickUpRow(val) {
                let found = false;
                const rows = document.querySelectorAll(".e-row");
                for (let x = 0; x < rows.length; x++) {
                        const cells = rows[x].querySelectorAll(".e-rowcell");
                        if (cells && cells.length > 3) {
				// the column with PZ code to compare
                                let row = cells[3].innerHTML;
                                if (row && row === val) {
                                        found = true;
                                        console.log("scanned value found at row: " + x);
                                        document.querySelector("#notfound").innerHTML='';
                                        this.$refs.grid.selectRow(x, true);
                                        break;
                                }
                        }
                }
                if (!found) {
                        console.log("scanned value not found");
                        document.querySelector("#notfound").innerHTML='Nie znaleziono';
                }
                return found;
        },
	gridfocus() {
                console.log("GRID FOCUS...");
                this.skanerclick();
        },
	wrocclick() {
                if(this.typ_zlecenia !== "")
		        this.$router.push({ path: "" + this.backto + "&typ_zlecenia=" + this.typ_zlecenia  });
                else
		        this.$router.push({ path: "" + this.backto });
	},
	rowSelected(args) {
    		let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
    		//alert(selectedrowindex); // To alert the selected row indexes.
    		let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		//alert(selectedrecords);
		this.selectSkrzynia(selectedrowindex);
		//console.log("INDEX:" + selectedrowindex);
		if (selectedrowindex.length > 0) {
			this.showwaga = true;
		} else {
			this.showwaga = false;
		}
		
	},
	selectSkrzynia(val1) {
		this.$root.$emit("update:skrzynia", val1);
	},
	getData() {
                return axios
                        .get(CONFIG.API_URL + this.url + this.mag, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
   },
   mounted() {
	var params = this.$route.query;
        var prev = "";
	var id_dok_mag = "";
	var id_zlecenia;
	if (params["mag"]) {
		id_dok_mag = params["mag"];
		this.mag = "/" + id_dok_mag;
	}
	if (params["id_zlecenia"]) {
		id_zlecenia = params["id_zlecenia"];
		this.id_zlecenia = id_zlecenia;
	}
        if (params["typ_zlecenia"]) {
                this.typ_zlecenia = params["typ_zlecenia"];
        }
        if (params["prev"]) {
             prev = params["prev"];
	     this.whereto = "?prev=opakowanie&mag=" + id_dok_mag + "&id_zlecenia=" + id_zlecenia + "&prev2=dokumentpzwydanie";
	     if (prev.indexOf("dokumentpzwydanie") != -1) {
		this.title = "WYDANIE Z MAGAZYNU > ZLECENIA > LISTA DOKUMENTÓW PZ > Opakowanie";
		this.backto = "/dokumentpzwydanie?id_zlecenia=" + id_zlecenia;

	     } else {
		this.title = "Panel główny > ODPADY > Opakowanie";
		this.backto = "/odpady";
	     }
        }
	var that = this;
        Storage.loadJWT("jwt").then(resp => {
                that.jwt = resp.access_token;
                that.getData().then(data => {
                        that.data = data;
                        if(this.typ_zlecenia === "Magazyn -22"){
                                //console.log(data)
                                setTimeout(() =>{
                                        //console.log(data[0].id)
                                        if(data[0].id !== null)
                                                this.$router.push({ path: "/waga" + this.whereto  + "&id_skrzyni=" + data[0].id +",1" + "&typ_zlecenia="+  this.typ_zlecenia });
                                        else{
                                                setTimeout(() =>{
                                                //console.log(data[0].id)
                                                if(data[0].id !== null)
                                                        this.$router.push({ path: "/waga" + this.whereto  + "&id_skrzyni=" + data[0].id +",1" + "&typ_zlecenia="+  this.typ_zlecenia });

                                                },2000)

                                        }
                                },2000)

                        }     
                });
  
        });
	document.querySelector(".wright").addEventListener('click', function() { that.dowagiclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
	document.querySelector(".wcenter").addEventListener('click', function() { that.skanerclick(); } );
	document.querySelector("#skaner").addEventListener('focus', function() { that.skanerstart(); } );
	document.querySelector(".e-grid").addEventListener('focusin', function() { that.gridfocus(); } );

	let reading = false;
	let UPC = '';
	document.querySelector("#skaner").addEventListener('keydown', function (e){

		const textInput = e.key || String.fromCharCode(e.keyCode);
        	const targetName = e.target.localName;
        	let newUPC = '';
        	if (textInput && textInput.length === 1){
            		newUPC = UPC+textInput;
			UPC = newUPC;
		
          		if (newUPC.length >= 10) {
            			//console.log('barcode scanned:  ', newUPC);
				UPC = "";
          		} 
       		} 
		if(!reading) {
        		reading = true;
        		setTimeout(() => {
            			newUPC = "";
            			reading = false;
				that.skanertext();
				//that.skanerclick();
       	 		}, 500);  //500 works fine for me but you can adjust it
    		}

	});
	// autoinitiate skaner
        this.skanerclick();

   },
   components: {
	SkrzyniaWydanie,
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.do_wagicommit {
        width: 200px;
        height: 50px;
}

.do_wagi1,.do_wagi2,.do_wagi3 {
        width: 50px;
        height: 50px;
	margin-right: 20px;
}

.title_left {
        text-align: left;
        width: 100%;
}
.items {
        float:none;
}
.skrzyniegrid {
        float: left;
        width: 95%;
        padding: 0% 2% 0% 2%;
}
.dokpz_right {
        padding: 10% 2% 0% 2%;
}
.dokpz_right2 {
        padding: 0% 2% 0% 2%;
}
.dokpz_right,.dokpz_right2 {
        float:right;
        width: 40%;

}
.dokpz_bottom {
        clear:both;
        width: 100%;
        padding: 2% 2% 0% 2%;
}
.wcenter {
        width: 60%;
        margin-left: 20%;
        margin-right: 20%;
        height: 50px;
        position:fixed;
        /*left: 435px;*/
        bottom: 50px;
}
.wright {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
#read {
        margin-left: auto;
        margin-right: auto;
}
.wbottom {
	clear:both;
}
.three {
	display:none;
}
.spinner{
        display:none;
        margin-left: auto;
        margin-right: auto;
        width: 64px;
        height: 64px;
        border: 8px solid;
        border-color: #3d5af1 transparent #3d5af1 transparent;
        border-radius: 50%;
        animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#notfound {
   font: 10px;
   font-style: italic;
   color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Opakowanie.vue